import { render, staticRenderFns } from "./comment-list.vue?vue&type=template&id=18d3483c&scoped=true"
import script from "./comment-list.vue?vue&type=script&lang=js"
export * from "./comment-list.vue?vue&type=script&lang=js"
import style0 from "./comment-list.vue?vue&type=style&index=0&id=18d3483c&prod&lang=scss"
import style1 from "./comment-list.vue?vue&type=style&index=1&id=18d3483c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3483c",
  null
  
)

export default component.exports